import React from 'react';
import PolicyHeader from './PolicyHeader';
import { styles } from '../styles';

const ComingSoon = ({ policy }) => {
  return (
    <div style={styles.container}>
      <PolicyHeader policy={policy} />
      <div style={{
        backgroundColor: '#fff3cd',
        border: '1px solid #ffc107',
        borderRadius: '8px',
        padding: '30px',
        textAlign: 'center',
        marginTop: '20px'
      }}>
        <div style={{ fontSize: '48px', marginBottom: '20px' }}>
          <span role="img" aria-label="Under construction">🚧</span>
        </div>
        <h2 style={{ fontSize: '24px', fontWeight: 'bold', marginBottom: '10px', color: '#856404' }}>
          Coming Soon
        </h2>
        <p style={{ fontSize: '16px', color: '#856404', marginBottom: '15px' }}>
          Amendments for this product type are currently under development.
        </p>
        <p style={{ fontSize: '14px', color: '#856404' }}>
          Product: <strong>{policy.product_name}</strong>
        </p>
      </div>
    </div>
  );
};

export default ComingSoon;
